var map = {
	"./testachats_logo_fr.png": "iyo0",
	"./testachats_logo_nl.png": "V1ud"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZlzI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos ^\.\/.*$
// module id = ZlzI
// module chunks = 1